export default function Features() {
  const features = [
    {
      title: '門號申辦',
      description: '各大電信方案比較，找到最划算的資費組合',
      image: 'https://public.readdy.ai/ai/img_res/0227b16961b8cf499e9833c0121267d3.jpg',
      icon: 'ri-signal-tower-line'
    },
    {
      title: '手機空機',
      description: '最新旗艦到入門機種，現貨供應',
      image: 'https://readdy.ai/api/search-image?query=Multiple%20premium%20smartphones%20arranged%20in%20elegant%20display%2C%20latest%20flagship%20mobile%20phones%20with%20sleek%20modern%20design%2C%20professional%20product%20photography%20with%20soft%20lighting%2C%20clean%20white%20and%20warm%20orange%20gradient%20background%2C%20minimalist%20tech%20aesthetic%20showcasing%20phone%20screens%20and%20cameras&width=600&height=800&seq=feature-002&orientation=portrait',
      icon: 'ri-smartphone-line'
    },
    {
      title: '配件專區',
      description: '各大配件品牌、APIOU中部總經銷',
      image: 'https://readdy.ai/api/search-image?query=Mobile%20phone%20accessories%20collection%20including%20protective%20cases%2C%20wireless%20chargers%2C%20earbuds%20and%20cables%2C%20organized%20product%20display%20on%20clean%20surface%2C%20professional%20e-commerce%20photography%20with%20soft%20shadows%2C%20simple%20white%20and%20light%20orange%20background%20emphasizing%20product%20quality&width=600&height=800&seq=feature-003&orientation=portrait',
      icon: 'ri-headphone-line'
    },
    {
      title: '二手機買賣',
      description: '高價收購舊機，嚴選二手機販售',
      image: 'https://readdy.ai/api/search-image?query=Certified%20pre-owned%20smartphones%20with%20quality%20inspection%20tags%2C%20professional%20second-hand%20phone%20trading%20service%2C%20clean%20refurbished%20devices%20on%20modern%20display%20stand%2C%20soft%20professional%20lighting%20with%20white%20and%20warm%20orange%20gradient%20background%2C%20trust%20and%20quality%20assurance%20theme&width=600&height=800&seq=feature-004&orientation=portrait',
      icon: 'ri-exchange-line'
    },
    {
      title: '手機平板電腦維修',
      description: '專業技師快速維修，原廠零件保固',
      image: 'https://readdy.ai/api/search-image?query=Professional%20technician%20repairing%20smartphone%20and%20tablet%20with%20precision%20tools%2C%20clean%20modern%20repair%20workspace%20with%20organized%20equipment%2C%20technical%20service%20environment%20with%20soft%20lighting%2C%20white%20and%20orange%20gradient%20background%20emphasizing%20expertise%20and%20professionalism&width=600&height=800&seq=feature-005&orientation=portrait',
      icon: 'ri-tools-line'
    },
    {
      title: '無卡分期',
      description: '免信用卡分期付款，輕鬆擁有新機',
      image: 'https://readdy.ai/api/search-image?query=Smartphone%20with%20installment%20payment%20plan%20interface%20showing%20monthly%20payment%20schedule%2C%20modern%20fintech%20service%20concept%20with%20calculator%20and%20payment%20icons%2C%20professional%20financial%20service%20visualization%20with%20clean%20white%20and%20warm%20orange%20gradient%20background%2C%20trust%20and%20affordability%20theme%20emphasizing%20easy%20payment%20options&width=600&height=800&seq=feature-006-v2&orientation=portrait',
      icon: 'ri-bank-card-line'
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16">
          我們的核心服務 💎
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl cursor-pointer transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl"
              style={{ paddingBottom: '133%' }}
            >
              <div className="absolute inset-0">
                <div className="w-full h-full">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent"></div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <div className="w-14 h-14 flex items-center justify-center bg-orange-500 rounded-xl mb-4">
                  <i className={`${feature.icon} text-2xl`}></i>
                </div>
                <h3 className="text-3xl font-bold mb-3">{feature.title}</h3>
                <p className="text-base text-white/90 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
